import { MeetingCenterPage } from './MeetingCenter'

export function WeeklyStatusPage() {
  return <MeetingCenterPage surface="weekly-status" />
}
